export default __webpack_public_path__ + "assets/default.2ca3180f8cdd6f14c4184439f06173cb.png";